import { YearQuery } from "../common/filter";
import GallerySliderMobile from "../common/slider-mobile";
import { useCarpets } from "../contexts/carpets-contex";
import { CarpetSectionProps } from "../types/common";

type Props = {
  data: CarpetSectionProps;
};

export default function MobileView({ data }: Props) {
  const {
    loadingMore,
    loading,
    setPageNo,
    carpets,
    year,
    type,
    setYear,
    setType,
  } = useCarpets();

  return (
    <div className="lg:hidden">
      <GallerySliderMobile
        yearQuery={YearQuery.CARPETS_YEAR}
        data={data}
        loading={loading}
        items={carpets}
        setPageNo={setPageNo}
        loadingMore={loadingMore}
        year={year}
        type={type}
        setYear={setYear}
        setType={setType}
      />
    </div>
  );
}
